import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faLinkedin, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { Mail } from 'lucide-react';
import LogoSvg from '../assets/images/header_logo_extracted.png';
import '../assets/styles/tokens.css';
import '../assets/styles/Footer.css';
import { useLanguage } from '../assets/js/LanguageContext';
import { openCookieSettings } from '../utils/cookieConsent';


const SOCIAL_LINKS = [
  { key: 'footer_instagram', href: 'https://www.instagram.com/shackleton_innovation/', icon: faInstagram },
  { key: 'footer_x', href: 'https://x.com/shkways', icon: faXTwitter },
  { key: 'footer_youtube', href: 'https://www.youtube.com/channel/UCAEz2GtNUpyYSC0z5RzIjIg', icon: faYoutube },
  { key: 'footer_linkedin', href: 'https://www.linkedin.com/showcase/the-pulse-pro/', icon: faLinkedin }
];

export const SUPPORT_EMAIL = 'support@thepul.se';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="tp-footer">
      <div className="tp-footer__inner">
        <div className="tp-footer__grid">
          <div className="tp-footer__brand">
            <Link to="/" className="tp-footer__logo-link">
              <img src={LogoSvg} alt="The Pulse" className="tp-footer__logo" />
            </Link>

            <p className="tp-footer__manifesto">{t('footer_manifesto_text')}</p>

            <div className="tp-footer__socials" aria-label={t('footer_socials_aria')}>
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.key}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={t(social.key)}
                  className="tp-footer__social"
                >
                  <FontAwesomeIcon icon={social.icon} />
                </a>
              ))}
            </div>
          </div>

          <nav className="tp-footer__col" aria-label={t('footer_col_nav')}>
            <p className="tp-footer__col-title">{t('footer_col_nav')}</p>
            <ul className="tp-footer__list">
              <li><Link to="/" className="tp-footer__link">{t('footer_home')}</Link></li>
              <li><Link to="/pricing" className="tp-footer__link">{t('footer_pricing')}</Link></li>
              <li><Link to="/about-us" className="tp-footer__link">{t('footer_aboutus')}</Link></li>
              <li><Link to="/contact-us" className="tp-footer__link">{t('footer_contactus')}</Link></li>
            </ul>
          </nav>

          <nav className="tp-footer__col" aria-label={t('footer_col_tools')}>
            <p className="tp-footer__col-title">{t('footer_col_tools')}</p>
            <ul className="tp-footer__list">
              <li><Link to="/pin" className="tp-footer__link">{t('footer_pin')}</Link></li>
              <li><Link to="/login" className="tp-footer__link">{t('login')}</Link></li>
              <li><Link to="/sign-up" className="tp-footer__link">{t('signup')}</Link></li>
              <li><a href="/privacy#privacy-section" className="tp-footer__link">{t('footer_privacy')}</a></li>
              <li><a href="/privacy#terms-section" className="tp-footer__link">{t('footer_terms')}</a></li>
              <li>
                <button type="button" className="tp-footer__link tp-footer__link--button" onClick={openCookieSettings}>
                  {t('cookies_settings')}
                </button>
              </li>
            </ul>
          </nav>

          <div className="tp-footer__col">
            <p className="tp-footer__col-title">{t('footer_col_contact')}</p>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="tp-footer__email"
              aria-label={t('footer_email_aria')}
            >
              <Mail size={16} strokeWidth={1.75} aria-hidden="true" />
              <span>{SUPPORT_EMAIL}</span>
            </a>
          </div>
        </div>

        <div className="tp-footer__baseline">
          <span>&copy; {new Date().getFullYear()} The Pulse</span>
          <span>{t('footer_rights')}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
